import * as React from 'react';

type BodyPropsType = {
  src: string;
  webpSrc?: string;
  alt: string;
  className: string;
  loadingProperty?: 'lazy' | 'eager';
};

const Image = ({
  src,
  webpSrc = '',
  alt,
  className,
  loadingProperty = 'lazy',
}: BodyPropsType) => {
  return webpSrc ? (
    <picture>
      <source srcSet={webpSrc} type="image/webp" />
      <img
        src={src}
        alt={alt}
        loading={loadingProperty}
        className={className}
      />
    </picture>
  ) : (
    <img className={className} src={src} alt={alt} loading={loadingProperty} />
  );
};

export default Image;
